// import React from "react";
// import { useNavigate } from "react-router-dom";
// import "./HomeCarousel.css";

// const slide = {
//   id: 1,
//   title: "UI UX design company in salem to make a better digital experience",
//   description:
//     "At MPeoples, we collaborate with top UI/UX designers to craft digital experiences that elevate your business to new heights.",
//   image: "/images/uibanner.webp",
//   coverimage: "/images/ci3.webp"
// };

// const Slider = () => {
//   const navigate = useNavigate();

//   const handleClicked = () => {
//     navigate("/contact");
//   };

//   return (
//     <div className="homecarousel-container">
//       <div className="homecarousel-wrapper">
//         <div className="homecarousel-slide">
//           <img
//             className="background-img"
//             src="/images/uibanner.webp"
//             alt="NO IMAGE"
//             fetchPriority="high" 
//             loading="eager" 
//             width={1200} 
//             height={630}
//             decoding="async" 
//             style={{ contentVisibility: "auto" }} 
//           />

//           <div className="overlay">
//             <div className="slide-content">
//               <div>
//                 <h2>{slide.title}</h2>
//                 <p>{slide.description}</p>
//               </div>
//               <div>
//                 <img
//                   className="homeslideimage"
//                   src={slide.coverimage}
//                   alt={slide.title || "Slide content"}
//                   effect="blur"
//                   placeholdersrc="/placeholder.webp"
//                   width={300}
//                   height={200}
//                   loading="lazy"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Slider;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Carousel } from "react-bootstrap";
import "./HomeCarousel.css";

const slides = [
  {
    id: 1,
    title: "UI UX design company in salem to make a better digital experience",
    description:
      "At MPeoples, we collaborate with top UI/UX designers to craft digital experiences that elevate your business to new heights.",
    image: "/images/uibanner.webp",
    coverimage: "/images/ci3.webp"
  },
  {
    id: 2,
    title: "Custom software solution in salem",
    description:
      "We delivers a custom software solutions to your business needs, enhancing efficiency, innovation, and growth with cutting-edge technology.",
    image: "/images/Appbanner.webp",
    coverimage: "/images/ci4.webp"
  },
  {
    id: 4,
    title: "Best web development services",
    description:
      "Experience the power of a seamless online journey with the cutting-edge web development services we provide for your business.",
    image: "/images/Webbanner.webp",
    coverimage: "/images/ci1.webp"
  },
  {
    id: 5,
    title: "Reliable mobile app development company in Salem for custom apps",
    description:
      "Transform your digital presence with our mobile app development expertise, offering innovative API driven solutions.",
    image: "/images/Appbanner.webp",
    coverimage: "/images/ci2.webp"
  },
  {
    id: 3,
    title:
      "Digital Marketing company in Salem to make a better digital experience",
    description:
      "At MPeoples, we collaborate with top UI/UX designers to craft digital experiences that elevate your business to new heights.",
    image: "/images/CDMbanner.webp",
    coverimage: "/images/ci5.webp"
  }
];

const Slider = () => {
  const [index, setIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const handleClicked = () => {
    navigate("/contact");
  };

  return (
    <div className="homecarousel-container">
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        interval={5000}
        controls={false}
        indicators={false}
        className="homecarousel-wrapper"
        slide={true}
        fade={false}
        pause={false}
      >
        {slides.map((slide, idx) => (
          <Carousel.Item key={slide.id}>
            <div className="homecarousel-slide">
              <img
                className="background-img"
                src={slide.image}
                alt={slide.title || "Slide image"}
                fetchPriority={idx === 0 ? "high" : "low"}
                loading={idx === 0 ? "eager" : "lazy"}
                width={1200}
                height={630}
                decoding="async"
              />

              <div className="overlay">
                <div className="slide-content">
                  <div>
                    <h2>{slide.title}</h2>
                    <p>{slide.description}</p>
                  </div>
                  <div>
                    <img
                      className="homeslideimage"
                      src={slide.coverimage}
                      alt={slide.title || "Slide content"}
                      effect="blur"
                      placeholdersrc="/placeholder.webp"
                      width={300}
                      height={200}
                      loading="lazy"
                    />
                  </div>
                </div>

                <div className="navigation-buttons">
                  <button
                    className="prevs"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIndex((idx - 1 + slides.length) % slides.length);
                    }}
                    aria-label="Previous slide"
                  >
                    ←
                  </button>
                  <span className="slide-indicator">
                    {idx + 1}/{slides.length}
                  </span>
                  <button
                    className="nexts"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIndex((idx + 1) % slides.length);
                    }}
                    aria-label="Next slide"
                  >
                    →
                  </button>
                </div>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default Slider;
